import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [isNavbarActive, setNavbarActive] = useState(false);
  const [isHeaderActive, setHeaderActive] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setHeaderActive(true);
      } else {
        setHeaderActive(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleNavbar = () => {
    setNavbarActive(!isNavbarActive);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  return (
    <header className={`header ${isHeaderActive ? "active" : ""}`} data-header>
      <div className="container">
        <Link to="/" className="logo">
          <img
            src="./assets/images/logo.png"
            alt="Taxi Business"
            style={{ height: "55px" }}
            className="logo-light"
          />
          <img
            src="./assets/images/logo.png"
            alt="Taxi Business"
            className="logo-dark"
            style={{ height: "55px" }}
          />
        </Link>

        <nav className={`navbar ${isNavbarActive ? "active" : ""}`} data-navbar>
          <div className="navbar-top">
            <Link to="/" className="logo">
              <img
                src="./assets/images/logo.png"
                alt="Taxi Business"
                style={{ height: "55px" }}
              />
            </Link>

            <button
              className="nav-close-btn"
              aria-label="close menu"
              onClick={toggleNavbar}
            >
              <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
            </button>
          </div>

          <ul className="navbar-list">
            <li>
              <Link to="/" className="navbar-link">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className="navbar-link">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/services" className="navbar-link">
                Services
              </Link>
            </li>
            <li className="navbar-link" style={{ position: "relative" }}>
              <span
                onClick={toggleDropdown}
                style={{ cursor: "pointer", display: "flex" }}
              >
                Our Fleets
                <span
                  style={{
                    marginLeft: "5px",
                    marginTop: "3px",
                    fontSize: "12px",
                    transition: "transform 0.3s",
                    transform: isDropdownOpen
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                  }}
                >
                  ▼
                </span>
              </span>

              {isDropdownOpen && (
                <ul
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: "0",
                    backgroundColor: "#fff",
                    padding: "10px 0",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    zIndex: 1000,
                    width: "150px",
                    borderRadius: "5px",
                  }}
                >
                  <li>
                    <Link
                      to="/taxi"
                      className="navbar-link"
                      style={{ padding: "5px 20px", color: "#000" }}
                    >
                      Taxi
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/rentals"
                      className="navbar-link"
                      style={{ padding: "5px 20px", color: "#000" }}
                    >
                      Rentals
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <Link to="/contacts" className="navbar-link">
                Contacts
              </Link>
            </li>
          </ul>

          <div className="wrapper">
            <a href="mailto:dadyjohn2004@gmail.com" className="contact-link">
              dadyjohn2004@gmail.com
            </a>
            <a href="tel:+254 791871179" className="contact-link">
              +254 791 871 179
            </a>
          </div>

          <ul className="social-list">
            <li>
              <Link to="/" className="social-link">
                <ion-icon name="logo-twitter"></ion-icon>
              </Link>
            </li>
            <li>
              <Link to="/" className="social-link">
                <ion-icon name="logo-facebook"></ion-icon>
              </Link>
            </li>
            <li>
              <Link to="/" className="social-link">
                <ion-icon name="logo-dribbble"></ion-icon>
              </Link>
            </li>
            <li>
              <Link to="/" className="social-link">
                <ion-icon name="logo-instagram"></ion-icon>
              </Link>
            </li>
            <li>
              <Link to="/" className="social-link">
                <ion-icon name="logo-youtube"></ion-icon>
              </Link>
            </li>
          </ul>
        </nav>

        <a href="tel:+254 791871179" className="btn btn-primary">
          Call Us
        </a>

        <button
          className="nav-open-btn"
          aria-label="open menu"
          onClick={toggleNavbar}
        >
          <ion-icon name="menu-outline" aria-hidden="true"></ion-icon>
        </button>

        <div
          className={`overlay ${isNavbarActive ? "active" : ""}`}
          data-nav-toggler
          data-overlay
        ></div>
      </div>
    </header>
  );
};

export default Header;
